import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 14px;
  display: flex;
  align-items: center;
  flex-direction: column;

  & > h4 {
    margin: 10px 0 5px;
  }

  & > p:first-of-type {
    color: #898989;
  }

  & > button {
    margin: 40px 0 20px;
    width: 100%;
  }
`

export const NewReservationInfoWrapper = styled.div`
  margin: 35px 0;
  display: flex;
  align-items: center;
  gap: 6px;
`